const categories = [
  {
    name: "📱 Gadgets & Tech",
    sub: [
      { name: "📲 Smartphones & Tablets" },
      { name: "🔌 Accessories for Phones & Tablets" },
      { name: "⌚ Smart Watches" },
      { name: "💻 Tablets" },
      { name: "🎧 Headphones" },
    ],
  },
  {
    name: "💻 Electronics",
    sub: [
      { name: "🖥️ Laptop & Computers" },
       { name: "📺 TV & DVD Equipment" }, 
      { name: "🎮 Video Game Consoles" },  // no
      { name: "🔊 Audio & Music Equipment" }, // no
      { name: "📸 Photo & Video Cameras" },
      { name: "📹 Security & Surveillance" },  // no
      { name: "📡 Networking Products" },  
    { name: "🖨️ Printers & Scanners" },  // no
      { name: "🧭 Computer Monitors" },  //no
      { name: "🧩 Computer Accessories" },  //no
      { name: "⚙️ Accessories & Supplies for Electronics" },   //no
      { name: "🎮 Video Games" }, //no
      
    ],
  },
  {
    name: "🚗 Vehicles & Transport",
    sub: [
      { name: "🚘 Cars" },
      { name: "🏍️ Motorcycles & Scooters" },
      { name: "🔧 Spare Parts & Accessories" },  //no
      { name: "🚜 Heavy Machinery" },  //no
     
    ],
  },
  {
    name: "👗 Style & Beauty",
    sub: [
      { name: "🧥 Men’s Fashion" },
      { name: "👠 Women’s Fashion" },
      { name: "💄 Cosmetics & Skincare" },
      { name: "💇 Hair & Beauty Tools" },  //no 
       { name: "🧳 Luggage & Travel Bags" }, 
    ],
  },
  {
    name: "🏠 Home, Furnishing & Appliances",
    sub: [
      { name: "🛋️ Furniture" },  //no
      { name: "🖼️ Home Decor" },  //no
      { name: "🍳 Kitchen Appliances" },  //no
      { name: "💡 Lighting" },  //no
      { name: "📺 Home Electronics" },  //no
    ],
  },
  {
    name: "🎯 Leisure & Entertainment",
    sub: [
      { name: "🏋️ Sports & Gym Gear" },
      { name: "🎸 Musical Instruments" },    //no

    ],
  },
  {
    name: "🏭 Commercial Equipment & Tools",
    sub: [
      { name: "🧾 Retail & Store Equipment" },
      { name: "🍽️ Restaurant & Catering Equipment" },
      

   
 
      { name: "🛡️ Safety & Security Equipment" }, //no
    ],
  },
  {
    name: "🏗️ Building Materials & Electricals",
    sub: [
      { name: "🏗️ Building Materials & Supplies" },
      { name: "⚡ Electrical & Wiring" },
     
      { name: "🚿 Water & Plumbing Systems" },
   
      { name: "🔋 Solar Energy & Power Systems" },  //no

    ],
  },
];

export default categories;